import React from "react";

export const AnswerBubble = ({ bg, textColor, borderColor, brand, inputBg, buttonBg, secTextColor,tilesBg }) => (
  <div
    style={{
      background: bg,
      border: `1px solid ${borderColor}`,
      borderRadius: 10,
      padding: "10px 12px",
      fontSize: 12,
      color: textColor,
      lineHeight: 1.55,
    }}
  >
    We offer a range of AI-powered solutions including{" "}
    <strong>smart search</strong>, <strong>chatbot integration</strong>, and{" "}
    <strong>analytics</strong> to help your business grow.
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 8,
        flexWrap: "wrap",
        gap: 4,
      }}
    >
      {[["↺ Clear", "📋 Copy"], ["👍 Good Answer", "👎 Bad Answer"]].map((grp, gi) => (
        <div key={gi} style={{ display: "flex", gap: 4 }}>
          {grp.map((label) => (
            <span
              key={label}
              style={{
                fontSize: 10,
                padding: "2px 6px",
                borderRadius: 5,
                border: `1px solid ${borderColor}`,
                background: buttonBg,
                color: "#ffffff",
                cursor: "default",
              }}
            >
              {label}
            </span>
          ))}
        </div>
      ))}
    </div>

    <div
      style={{
        display: "flex",
        gap: 6,
        marginTop: 8,
        overflow: "hidden",
        flexWrap: "wrap",
      }}
    >
        <div style={{width:"100%"}}>
            <p style={{color:"#c0c0c0"}}>Answer based on the following sources:</p>
        </div>

      {["Services page", "About us"].map((t) => (
        <div
          key={t}
          style={{
            flex: "0 0 110px",
            background: tilesBg,
            border: `1px solid ${borderColor}`,
            borderRadius: 7,
            padding: "6px 8px",
          }}
        >
          <div
            style={{ fontSize: 11, fontWeight: 600, color: textColor, marginBottom: 2 }}
          >
            {t}
          </div>
          <div style={{ fontSize: 10, color: textColor, opacity: 0.5 }}>
            yoursite.com
          </div>
        </div>
      ))}
    </div>
  </div>
);